import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent } from '../ui/card';

const FreightFooter = ({ freightCharges, setFreightCharges, grandTotal }) => (
  <Card>
    <CardContent className="p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Label className="text-sm font-semibold text-gray-700">Freight Charges</Label>
          <Input type="number" min="0" step="0.01" value={freightCharges}
            onChange={e => setFreightCharges(e.target.value)}
            placeholder="0" className="h-9 w-40 text-right text-sm"
            onWheel={e => e.target.blur()} data-testid="pe-freight-charges" />
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500">Grand Total (incl. freight)</p>
          <p className="text-xl font-bold text-gray-900" data-testid="pe-grand-total-with-freight">
            {(grandTotal + (parseFloat(freightCharges) || 0)).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 })}
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);

export default FreightFooter;
